import {UserConfigList} from "components/front/APP/User/Config/List/UserConfigList"
import React from "react"

export const UserConfigListRoute = (props: any) => {
  return <div>
    <UserConfigList />
  </div>

}